import React, { useEffect, useState } from 'react';
import dateformat from 'dateformat';
import styles from './index.module.scss';
import { useStore, StoreTypes } from 'context';
import { Typography, Button, makeStyles,  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,TablePagination } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import Icon from "components/Icon";
import Loading from "components/Loading";
import { getNaniOneClassCookie } from "components/Login/Popup/login.js";

const tableContainerStyles = makeStyles({
  root: {
    "& .MuiTableCell-stickyHeader": {
      padding: "8px 16px",
      fontSize: "16px",
      color: "#637381",
      borderBottom: "0px",
      userSelect: "none",
      "&:nth-child(1)": {
        borderRadius: "8px 0px 0px 8px",
      },
      "&:last-child": {
        borderRadius: "0px 8px 8px 0px",
      },
      "& span": {
        cursor: "pointer",
        "& svg": {
          fontSize: "12px",
        },
      },
    },
    "& .MuiTableCell-body": {
      borderBottom: "0px",
      padding: "0px 16px",
      height: "56px",
    },
  },
});

const resultButtonStyles = makeStyles({
  root: {
    height: "36px",
    width: "100px",
    minWidth: "88px",
    color: "white",
    background: "#315D83",
    fontSize: "14px",
    fontWeight: "700",
    marginLeft: "8px",
    boxShadow: "none",
    "&:disabled": {
      background: "lightGrey",
    },
    "&:hover": {
      background: "#4786bb",
    },
  },
});


const refreshButtonMakeStyles = makeStyles({
  root: {
    height: "30px",
    width: "72px",
    minWidth: "88px",
    color: "#212B36",
    background: "#74CAFF",
    fontSize: "14px",
    fontWeight: "700",
    boxShadow: "none",
    borderRadius: "8px",
    "&:disabled": {
      background: "lightGrey",
    },
    "&:hover": {
      background: "#74CAFF",
    },
  },
});

function difficultyName(difficulty) {
  if(difficulty === 0) {
    return '基礎';
  }
  if(difficulty === 1) {
    return '進階';
  }
  return '挑戰';
}

export default function ExamList() {
  
  const router = useStore(StoreTypes.router);
  const [{ token }] = useStore(StoreTypes.user);
  const tableStyles = tableContainerStyles();
  const buttonStyles = resultButtonStyles();
  const refreshButtonStyles = refreshButtonMakeStyles();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState('desc');
  const [data , setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageRange, setPageRange] = useState('');
  const [loading, setLoading] = useState(true);
  const tokenCookie = getNaniOneClassCookie("nani_oneclass_login_token");

  const updateTime = dateformat(Date.now(), 'yyyy/mm/dd HH:MM')

  const getList = async () => {

    const params = new URLSearchParams(window.location.search);
    const preparationId = params.get('preparationId');
    const bookId = params.get('bookId');
    const tempPageIndex = params.get('pageIndex');

    let newParams = new URLSearchParams({ 
      preparationId,
      bookId,
      pageIndex: tempPageIndex,
      sort,
      sortBy: 'createdAt',
      skip: page * limit,
      limit,
    });

    fetch(`${process.env.REACT_APP_API_DOMAIN}/exams?${newParams.toString()}`, {
      method: 'GET',
      headers: {
        'Authorization': token
      }
    }).then((res) => { 
      return res.json()
    }).then((res) => {
      setData(res.data.exams);
      setTotal(res.data.total);
      
    }).finally(() => {
      setLoading(false);
    });
  }
  useEffect(() => {
    if (!tokenCookie || !JSON.parse(tokenCookie)) {
      alert("請登入南一 NaniBook");
      router.history.replace("/bookshelf");
    }
  }
  , []);

  useEffect(() => {
    if(token) {
      setLoading(true);
      getList();
    }
  }, [page, limit, sort, token]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const pageShow = params.get('pageShow');
    if(pageShow) {
      setPageRange(pageShow);
    }
  }, []);

  const toExamStudentList = (item) => {

    const params = new URLSearchParams(window.location.search);
    const preparationId = params.get('preparationId');
    const bookId = params.get('bookId');
    const tempPageRange = params.get('pageShow');
    const tempPageIndex = params.get('pageIndex');

    window.location.href = `/examStudentList?quizId=${item.quizId}&schoolYear=${item.schoolYear}&quizCode=${item.quizCode}&bookId=${bookId}&preparationId=${preparationId}&pageRange=${tempPageRange}&pageIndex=${tempPageIndex}&difficulty=${item.difficulty}&examType=${item.examType}`;
  }

  const iconName = () => {
    if (sort === 'asc') {
      return 'arrowUp';
    } else if (sort === 'desc') {
      return 'arrowDown';
    }
  }

  const handleSort = () => {
    if(sort === 'asc') {
      setSort('desc');
    }
    if(sort === 'desc') {
      setSort('asc');
    }
  }

  const getExamName = () => {
    if(data.length > 0) {
      return data[0].examName;
    }
    return ''
  }

  return (
  <div>
    <div className={styles.header}>
      <div className={styles.container}>
        <img className="logo" src="img/logo.svg" alt="onebook" />
      </div>
    </div>
    {
      loading && <Loading />
    }
    {
      !loading && data.length === 0 && (
        <div className={styles.empty}>
          <img src="img/empty.svg" alt="empty" />
          <Typography>目前沒有任何測驗</Typography>
        </div>
      )
    }
    {
      !loading && data.length > 0 && (
        <div className={styles.mainBg}>
        <div className={styles.container}>
          <div className={styles.block}>
            <div className={styles.blockTitle}>
             { getExamName() }
            </div>
            <div className={styles.examInfo}>
              <div className={styles.examInfoItem}>
                <Typography>題目類型：派測驗</Typography>
              </div>
              <div className={styles.examInfoItem}>
                <Typography>派出範圍：第{pageRange}頁</Typography>
              </div>
              <div className={styles.examInfoItem}>
                <Typography>注意事項：請更新頁面以取得最新紀錄</Typography>
              </div>
            </div>
          </div>
          <div className={styles.blockBottom}>
            <div className={styles.examTableTitle}>
              <div className={styles.blockTitle}>
              測驗列表
              </div>
              <div className={styles.updateTimeBlock}>
                <div>最後更新時間：{ updateTime }</div>
                <Button classes={refreshButtonStyles} variant='contained' color="primary" startIcon={<RefreshIcon />} onClick={() => window.location.reload()}>
                  更新
                </Button>
              </div>
            </div>
            <TableContainer classes={tableStyles}>
                      <Table stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">
                              <div className={styles.tableSort} onClick={handleSort}>
                              派出時間
                              <Icon
                                type="text"
                                name={iconName()}
                              />
                              </div>
  
                            </TableCell>
                            <TableCell align="left">派卷難度</TableCell>
                            <TableCell align="left" />
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {
                            data.map((item, index) => (
                              <TableRow key={index}>
                                <TableCell align="left">{dateformat(item.createdAt, 'yyyy/mm/dd HH:MM')}</TableCell>
                                <TableCell align="left">{difficultyName(item.difficulty)}</TableCell>
                                <TableCell align="right">
                                  <Button classes={buttonStyles} variant="contained" color="primary" onClick={() => toExamStudentList(item)}>
                                    查看結果
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <TablePagination
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      component="div"
                      labelRowsPerPage="每頁列數"
                      count={total}
                      rowsPerPage={limit}
                      page={page}
                      onChangePage={(event, _page) => setPage(_page)}
                      onChangeRowsPerPage={event => {
                        setLimit(parseInt(event.target.value, 10));
                        setPage(0);
                      }}
                    />
          </div>  
        </div>
      </div>
      )
    }
   
  </div>)
}